import React, { useState, useEffect } from 'react'
import { Query } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import { AutoComplete, message } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import {
  Div, H3, Button, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import { theme } from '../../../styles/_variables'
import { SHIPPING_ORDERS, JOB_SEARCH } from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import './style-css.css'
import { Wrapper, SuperReportModal } from '../../../components/shipping-order-components'
import PERMISSION from '../../../constants/permissions'
import history from '../../../history'
import Table from './table'
import { status } from '../constants'
import { MobileShippingList } from './mobile'

const { color } = theme

const Index = ({ props }) => {
  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)
  if (myInfoLoading || _.isEmpty(myInfo)) return <Loading center='true' />
  if (_.includes([11, 12, 13], myInfo.myInfo.Roles[0].id)) return <MobileShippingList driverId={myInfo.myInfo.driverId} />
  if (myInfo.myInfo.Roles[0].id === 11) return <DriverShippingList driverId={myInfo.myInfo.driverId} />
  return <ShippingList props={props}/>
}

const DriverShippingList = ({ driverId }) => {
  const [word, setword] = useState(undefined)
  const [checkDelivered, setCheckDelivered] = useState(false)
  const [check, setCheck] = useState([])
  const [shippingOrders, setShippingOrders] = useState([])
  const [dateType, setDateType] = useState()
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบสั่งบรรทุก</H3>
        <Div display='flex' flexDirection='row' alignItems='center'>
        </Div>
      </Div>
      <List
        word={word} checkDelivered={checkDelivered}
        setCheckDelivered={setCheckDelivered} check={check}
        setCheck={setCheck} shippingOrders={shippingOrders}
        setShippingOrders={setShippingOrders}
        dateType={dateType}
        setDateType={setDateType}
        driverId={driverId}
        isDriver={true}
      />
    </Div>
  )
}

const ShippingList = ({ props }) => {
  const [searchText, setSearchText] = useState('')
  const [word, setword] = useState(undefined)
  const [search, setsearch] = useState('')
  const [Job, setJob] = useState('')
  const [checkDelivered, setCheckDelivered] = useState(false)
  const [check, setCheck] = useState([])
  const [shippingOrders, setShippingOrders] = useState([])
  const [dateType, setDateType] = useState()
  const [modal, setModal] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการใบสั่งบรรทุก</H3>
        <Div display='flex' flexDirection='row' alignItems='center'>
          <Query
            query={JOB_SEARCH}
            fetchPolicy='cache-and-network'
            variables={{
              key: search,
            }}
          >{({ data, error, loading }) => {
            if (loading && _.isUndefined(data.searchJobByVolumnNumber)) return <Loading size='small'/>
            if (error) return <P>เกิดข้อผิดพลาด</P>
            return (
              <Div>
                {loading && <Loading size='small' style={{ marginRight: 8 }}/>}
                <AutoComplete
                  dataSource={data.searchJobByVolumnNumber.lists.map(v => v.key)}
                  value={searchText}
                  style={{ width: 200 }}
                  onSelect={(e) => {
                    setword(e)
                    setJob(_.find(data.searchJobByVolumnNumber.lists, o => o.key === e))
                    setCheck([])
                    setShippingOrders([])
                    setSearchText(e)
                  }}
                  onSearch={(e) => {
                    if (e === '') {
                      setword(undefined)
                      setJob([])
                      setCheck([])
                      setShippingOrders([])
                      setSearchText('')
                    } else {
                      setsearch(e)
                      setSearchText(e)
                    }
                  }}
                  placeholder="ใส่เลขที่สัญญางาน"
                />
              </Div>
            )
          }}
          </Query>
          <Button
            // disabled={!_.includes(window.perms, PERMISSION.CREATE_INVOICE) || _.isEmpty(word) || !checkDelivered || _.isEmpty(check)}
            margin='0 0 0 16px'
            disabled={!_.includes(window.perms, PERMISSION.VIEW_SHIPPING_ORDER)}
            text='พิมพ์รายงานใบสั่งบรรทุก'
            onClick={() => {
              setModal(true)
            }}
          />
          <DynamicButtonLink
            link={`/shipping-order/add/${!_.isUndefined(Job) && Job.id}`}
            condition={_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER) && !_.isEmpty(word) && !moment(!_.isUndefined(Job) && Job.jobInfo && Job.jobInfo.contractEnd).isBefore() && word !== 'ALL'}
            props={{ text: moment(!_.isUndefined(Job) && Job.jobInfo && Job.jobInfo.contractEnd).isBefore() && !_.isEmpty(word) ? 'สัญญาหมดอายุแล้ว' : 'สร้างใบสั่งรถบรรทุก', margin: '0 16px' }}
          />
          <Button
            // disabled={!_.includes(window.perms, PERMISSION.CREATE_INVOICE) || _.isEmpty(word) || !checkDelivered || _.isEmpty(check)}
            disabled={!_.includes(window.perms, PERMISSION.CREATE_INVOICE) || _.isEmpty(word) || _.isEmpty(check)}
            text='สร้างใบวางบิล / ใบแจ้งหนี้'
            onClick={() => {
              const initialUnit = _.map(shippingOrders, v => v.unit)[0]
              if (_.every(shippingOrders, v => v.unit === initialUnit)) {
                history.push({ pathname: '/invoice/add', state: { shippingOrders, job: Job } })
              } else {
                message.error('ใบสั่งบรรทุกที่ท่านเลือก มีหน่วยที่ใช้คิดเงินไม่เหมือนกัน ไม่สามารถนำมาสร้างใบวางบิล / ใบแจ้งหนี้ได้')
              }
            }}
          />
        </Div>
      </Div>
      <List
        word={word} checkDelivered={checkDelivered}
        setCheckDelivered={setCheckDelivered} check={check}
        setCheck={setCheck} shippingOrders={shippingOrders}
        setShippingOrders={setShippingOrders}
        dateType={dateType}
        setDateType={setDateType}
        filterStatus={props?.match?.params?.status}
      />
      <SuperReportModal
        modal={modal}
        setModal={setModal}
      />
    </Div>
  )
}

export const List = ({
  word, checkDelivered, setCheckDelivered, check, setCheck, setShippingOrders, shippingOrders, dateType, setDateType, driverId, isDriver, filterStatus,
}) => {
  const [current, setCurrent] = useState(0)
  const [sorted, setSorted] = useState([{ id: 'updatedAt', desc: true }])
  const [filtered, setFiltered] = useState({
    startAssignDate: null,
    endAssignDate: null,
    startRecordDate: null,
    endRecordDate: null,
    status: filterStatus ? status[filterStatus.toUpperCase()] : undefined,
  })

  useEffect(() => { setCurrent(0) }, [word])
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={SHIPPING_ORDERS}
        fetchPolicy='network-only'
        variables={{
          key: word,
          driverId,
          limit: 50,
          offset: current * 50,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({
        data, loading, error, refetch,
      }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div margin='auto'>
            <Table
              data={data}
              filtered={filtered}
              current={current}
              setCurrent={setCurrent}
              refetch={refetch}
              check={check}
              setCheck={setCheck}
              totalCount={data.ShippingorderList.totalCount}
              word={word}
              checkDelivered={checkDelivered}
              shippingOrders={shippingOrders}
              setShippingOrders={setShippingOrders}
              setCheckDelivered={setCheckDelivered}
              setFiltered={setFiltered}
              setSorted={setSorted}
              dateType={dateType}
              isDriver={isDriver}
              driverId={driverId}
              setDateType={setDateType}
              isCheckAll={!_.isEmpty(data.ShippingorderList.lists) && !_.includes(data.ShippingorderList.lists.map(v => _.includes(check, v.id)), false)}
              // checkDisabled={_.isUndefined(word) || !checkDelivered || _.isEmpty(data.ShippingorderList.lists) }
              checkDisabled={_.isUndefined(word) || _.isEmpty(data.ShippingorderList.lists) || _.size(_.filter(data.ShippingorderList.lists, o => o.status !== status.DELIVERED)) > 0}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Index
